import * as THREE from "three";

// [NEW] Shared material for tire trails
const sharedTrailMaterial = new THREE.LineBasicMaterial({
  color: 0x553311,
  linewidth: 3,
  opacity: 0.7,
  transparent: true,
});

/**
 * Klasa odpowiedzialna za renderowanie śladów gąsienic czołgu
 * Uses ring buffer for O(1) updates instead of O(n) array shifting
 */
export class TireTrail {
  public mesh: THREE.Line;
  private maxPoints: number = 100;
  // Ring buffer optimization - track head index instead of shifting array
  private headIndex: number = 0;
  private pointCount: number = 0;

  constructor() {
    // Tworzymy geometrię dla śladu
    const geometry = new THREE.BufferGeometry();

    // Tworzymy tablicę dla punktów (x, y, z) * maxPoints
    const positions = new Float32Array(this.maxPoints * 3);

    // Inicjalizacja wszystkich punktów na 0
    for (let i = 0; i < this.maxPoints * 3; i++) {
      positions[i] = 0;
    }

    // Dodajemy atrybuty do geometrii
    geometry.setAttribute("position", new THREE.BufferAttribute(positions, 3));

    // Materiał dla śladu
    // [CHANGED] Use shared material
    const material = sharedTrailMaterial;

    // Tworzymy linię
    this.mesh = new THREE.Line(geometry, material);
    this.mesh.frustumCulled = false; // Zapobiega znikaniu, gdy linia wychodzi poza pole widzenia
  }

  /**
   * Zwraca obiekt Three.js reprezentujący ślad
   */
  getMesh(): THREE.Line {
    return this.mesh;
  }

  /**
   * Aktualizuje pozycję śladu na podstawie pozycji gąsienicy
   * Uses ring buffer - O(1) complexity instead of O(n) array shifting
   * @param position Pozycja gąsienicy w świecie
   */
  update(position: THREE.Vector3) {
    if (this.mesh.geometry && this.mesh.geometry.attributes.position) {
      const positions = this.mesh.geometry.attributes.position.array as Float32Array;

      // Ring buffer: write at head position, no shifting needed
      const writeIndex = this.headIndex * 3;
      positions[writeIndex] = position.x;
      positions[writeIndex + 1] = 0.01; // Lekko nad ziemią
      positions[writeIndex + 2] = position.z;

      // Move head forward (wrap around)
      this.headIndex = (this.headIndex + 1) % this.maxPoints;
      if (this.pointCount < this.maxPoints) {
        this.pointCount++;
      }

      // Update draw range to only draw filled points
      this.mesh.geometry.setDrawRange(0, this.pointCount);

      // Oznacz, że dane się zmieniły
      this.mesh.geometry.attributes.position.needsUpdate = true;
    }
  }
}
